<mat-menu xPosition="before" id="header-onboarding-mobile" class="header-onboarding-mobile">
  <ng-container *transloco="let t">
    <div class="menu-header">
      Menu
      <mat-icon
        (click)="closeMenu.emit()"
      >
        cancel
      </mat-icon>
    </div>
    <button
      id="lnr-menu-router-to-benefits"
      mat-menu-item
      (click)="click('benefits')"
    >
      {{ t('onboarding-benefits') }}
    </button>
    <button
      id="lnr-menu-router-to-rewards"
      mat-menu-item
      (click)="click('rewards')"
    >
      {{ t('onboarding-rewards') }}
    </button>
    <button
      id="lnr-menu-router-to-categories"
      mat-menu-item
      (click)="click('categories')"
    >
      {{ t('onboarding-categories') }}
    </button>
    <button
      id="lnr-menu-router-to-faq"
      mat-menu-item
      (click)="click('faq')"
    >
      {{ t('onboarding-faq') }}
    </button>
    <button
      id="lnr-menu-router-to-about"
      mat-menu-item
      (click)="click('about')"
    >
      {{ t('onboarding-about') }}
    </button>
  </ng-container>
</mat-menu>
